import { killEvent } from 'event-helpers';

export default function KillEvent(target, name, description) {
  const newDescription = { ...description };
  const origValue = newDescription.value;

  newDescription.value = function newDescriptionValue(e, ...args) {
    killEvent(e);

    origValue.apply(this, e, ...args);
  };

  return newDescription;
}
